import GridAtividadesSelecao from './GridAtividadesSelecao';

export default GridAtividadesSelecao;